import React from "react";
import { styled } from "../../../stitches.config";
import { Box } from "../../primitives";

const CircleIcon = styled(Box, {
  width: "26px",
  height: "26px",
  backgroundColor: "#f97316",
  color: "#ffffff",
  fontSize: "16px",
  fontWeight: "bold",
  borderRadius: "9999px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "2px solid #1f2937",
});

export const FirstEditionIcon = () => <CircleIcon>1</CircleIcon>;
